import React from 'react';
import './Floaticons.css';
import mailData from '../data/mailData.js';
function Floaticons() {
  return (
    <>
      <div className="float-wrap">
        <div className="float-box box1">
          <img src="images/Contact-icon.png" alt="icons" className='float-icons' />
          <p><a href={`mailto:${mailData.securityindlearning}`}>Contact Us</a></p>
        </div>
      </div>
    </>
  )
}

export default Floaticons